import { FILTER_TYPES } from "../../../../utils/filter";

const filterConfig = [
  {
    placeholder: "Ingresa el nombre del usuario que estas buscando",
    type: FILTER_TYPES.TEXT,
    filterTitle: "Nombre",
    dataField: "firstName",
  },
  {
    placeholder: "Ingresa el correo electrónico del usuario que estas buscando",
    type: FILTER_TYPES.TEXT,
    filterTitle: "Email",
    dataField: "email",
  },
];

export default filterConfig;
